import React from 'react';
import { TRACK_CAT } from '../constants';
import {
  screenMdMin,
  cssColorValue,
  LogoSpotify,
} from '@spotify-internal/encore-web-v6';
import styled from 'styled-components';
import { Link } from '@spotify-internal/frodor-modules';

const StyledLogo = styled(LogoSpotify)`
  color: ${cssColorValue('textBase')};
  height: 26px;
  @media (min-width: ${screenMdMin}) {
    height: 36px;
  }
`;

export const Logo = () => {
  return (
    <Link
      external
      href="https://www.spotify.com"
      track={[TRACK_CAT, 'Logo']}
      dataTestId="footer-logo"
    >
      <StyledLogo />
    </Link>
  );
};
